<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        :columns="columns"
        v-model:search="searchFrom"
        @fetch="fetch"
        ref="tableRef"
        tableId="lbuSalesSkillsCoachingRecord"
      >
        <template #search>
          <a-form :model="searchFrom">
            <dc-form-item label="状态">
              <a-radio-group
                v-model:value="searchFrom.status"
                optionType="button"
                :options="statusEnum"
                @change="handleQueryChange()"
              />
            </dc-form-item>
            <dc-form-item label="辅导人">
              <UserSelect permission v-model:value="searchFrom.mentorList" mode="multiple" allowClear />
            </dc-form-item>
            <dc-form-item label="被辅导人">
              <UserSelect permission v-model:value="searchFrom.trainee" allowClear />
            </dc-form-item>
            <dc-form-item label="本次辅导时间">
              <cos-range-picker
                v-model:startTime="searchFrom.tutoringStartTime"
                v-model:endTime="searchFrom.tutoringEndTime"
              />
            </dc-form-item>
            <dc-form-item label="辅导人区域">
              <CustomerAreaCascader type="search" appId="cos_lbu" v-model:ids="searchFrom.mentorRegionList" />
            </dc-form-item>
            <dc-form-item label="被辅导人区域">
              <CustomerAreaCascader type="search" appId="cos_lbu" v-model:ids="searchFrom.traineeRegionList" />
            </dc-form-item>
            <dc-form-item label="回顾时间">
              <cos-range-picker
                v-model:startTime="searchFrom.reviewStartTime"
                v-model:endTime="searchFrom.reviewEndTime"
              />
            </dc-form-item>
            <dc-form-item name="id" label="ID">
              <a-input v-model:value="searchFrom.id" allowClear placeholder="请输入" />
            </dc-form-item>
          </a-form>
        </template>
        <template #button>
          <a-button type="primary" @click="addRow" v-permission="'lbu_sale_skills_coaching_add_btn'"> 新增 </a-button>
          <ExportButton
            appId="cos_lbu"
            taskType="329"
            :search="handledQueryParams(searchFrom)"
            v-permission="'lbu_sale_skills_coaching_export_btn'"
            >导出</ExportButton
          >
        </template>
        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'mentorRegion' || column.dataIndex === 'traineeRegion'">
            <CustomerAreaCascaderText appId="cos_lbu" :value="text" />
          </template>
          <template v-if="column.dataIndex === 'action'">
            <MoreButton>
              <a-button type="link" :disabled="record.status === 2" @click="editRow(record)" v-permission="'lbu_sale_skills_coaching_edit_btn'">
                编辑
              </a-button>
              <a-button type="link" @click="deleteRow(record)" v-permission="'lbu_sale_skills_coaching_del_btn'">
                删除
              </a-button>
              <a-button
                type="link"
                :disabled="record.status === 2"
                @click="confirmRow(record)"
                v-permission="'lbu_sale_skills_coaching_confirm_btn'"
              >
                确认
              </a-button>
              <a-button type="link" :disabled="record.status !== 2 || record.reviewTime != undefined || shareInfo.getUserInfo().work_code !== record.mentor" @click="reviewRow(record)" v-permission="'lbu_sale_skills_coaching_review_btn'">
                回顾
              </a-button>
              <a-button type="link" :disabled="record.status !== 2" @click="commentRow(record)" v-permission="'lbu_sale_skills_coaching_comment_btn'">
                评论
              </a-button>
            </MoreButton>
          </template>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { DcMessage, DcConfirm } from '@dc-platform/dc-components'
import { reactive, computed, ref, onBeforeMount, onMounted } from 'vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { statusEnum } from './dataConfig'
import { salesSkillsCoachingList, salesSkillsCoachingDelete, salesSkillsCoachingConfirm } from '@/api/yuntuSales/salesSkillsCoaching'
import Modal from '@/hooks/modalType'
import { shareInfo } from '@dc-platform/dc-interaction'
import { cloneDeep } from 'lodash-es'

const router = useRouter()
const route = useRoute()
const tableRef = ref()
const searchFrom = reactive<any>({})
onBeforeMount(() => {
  if (route.query.queryParams) {
    const queryParams = JSON.parse(route.query.queryParams as any)
    console.log(queryParams)
    if (queryParams) {
      const status = queryParams.status
      if (status) {
        searchFrom.status = status
      }
      const tutoringStartTime = queryParams.tutoringStartTime
      if (tutoringStartTime) {
        searchFrom.tutoringStartTime = tutoringStartTime
      }
      const tutoringEndTime = queryParams.tutoringEndTime
      if (tutoringEndTime) {
        searchFrom.tutoringEndTime = tutoringEndTime
      }
      const mentorList = queryParams.mentorList
      if (mentorList) {
        searchFrom.mentorList = mentorList
      }
    }
  }
})
const handledQueryParams = (params: any) => {
  const queryParams = cloneDeep(params)
  const mentors = queryParams.mentorList
  if (mentors && mentors.length === 1) {
    queryParams.mentor = mentors[0]
    delete queryParams.mentorList
  }
  return queryParams
}
const fetch = (searchFrom: any, callBack: (res: any) => void) => {
  const queryForm = handledQueryParams(searchFrom)
  salesSkillsCoachingList(queryForm).then((res) => {
    callBack(res)
  })
}

const columns = computed(() => [
  {
    title: 'ID',
    dataIndex: 'id',
    cosType: 'link',
    path: '/lbu/salesSkillsCoaching/view',
    query: ['id'],
    fixed: 'left',
    width: 200
  },
  { title: '辅导人', dataIndex: 'mentorName' },
  { title: '辅导人区域', dataIndex: 'mentorRegion' },
  { title: '被辅导人', dataIndex: 'traineeName' },
  { title: '被辅导人区域', dataIndex: 'traineeRegion' },
  { title: '本次辅导时间', dataIndex: 'tutoringTime' },
  { title: '状态', dataIndex: 'status', dicData: statusEnum },
  { title: '客户名称', dataIndex: 'customerName' },
  { title: '本阶段重点关注和提升的技能', dataIndex: 'keyFocus' },
  { title: '本次拜访的亮点和需要提升', dataIndex: 'visitHlt' },
  { title: '后续计划', dataIndex: 'subPlans' },
  { title: '回顾时间', dataIndex: 'reviewTime' },
  { title: '操作', dataIndex: 'action', width: 200, fixed: 'right' }
])

const handleQueryChange = () => {
  tableRef.value?.search()
}

const addRow = (row: any) => {
  router.push('/lbu/salesSkillsCoaching/add')
}

const editRow = (row: any) => {
  router.push({
    path: '/lbu/salesSkillsCoaching/edit',
    query: {
      id: row.id
    }
  })
}

const deleteRow = (row: any) => {
  Modal.delete({
    name: row.id,
    onOk() {
      salesSkillsCoachingDelete({ id: row.id }).then(() => {
        DcMessage.success('删除成功')
        tableRef.value?.delFetch()
      })
    }
  })
}

const confirmRow = (row: any) => {
  DcConfirm.warning({
    title: '操作提示！',
    content: '是否确认此操作？',
    cancelText: '取消',
    okText: '继续',
    onOk() {
      salesSkillsCoachingConfirm({ id: row.id }).then(() => {
        DcMessage.success('操作成功')
        tableRef.value.fetch()
      })
    }
  })
}

const reviewRow = (row: any) => {
  router.push({
    path: '/lbu/salesSkillsCoaching/review',
    query: {
      id: row.id
    }
  })
}

const commentRow = (row: any) => {
  router.push({
    path: '/lbu/salesSkillsCoaching/comment',
    query: {
      id: row.id
    }
  })
}
</script>
<script lang="ts">
export default { name: 'DcCosLbuSalesSkillsCoaching' }
</script>

<style scoped></style>
